// const BILLBOARD_V2 = "MnAw7gugv1gd4b6jjh7amEVXTFddt4rqZDGs6ZMN7Vz"
const BILLBOARD_V3 = "BqCHaPbg9KV53XpAG53AtH4L9zpD4q9AaTrutfKaR5jD"

export const BILLBOARD_PROGRAM_ID = BILLBOARD_V3
